<template>
    <div class="team-form">
        <div v-for="match in matches">
            <span v-if="match.goalshome === match.goalsguest" class="team-form-item team-form-item-draw" data-testid="result-trend">{{ $t('matches_drawn_short') }}</span>
            <span v-else-if="match.fk_team_home === teamId && match.goalshome < match.goalsguest" class="team-form-item team-form-item-lost" data-testid="result-trend">{{ $t('matches_lost_short') }}</span>
            <span v-else-if="match.fk_team_home === teamId && match.goalshome > match.goalsguest" class="team-form-item team-form-item-won" data-testid="result-trend">{{ $t('matches_won_short') }}</span>
            <span v-else-if="match.fk_team_guest === teamId && match.goalshome < match.goalsguest" class="team-form-item team-form-item-won" data-testid="result-trend">{{ $t('matches_won_short') }}</span>
            <span v-else-if="match.fk_team_guest === teamId && match.goalshome > match.goalsguest" class="team-form-item team-form-item-lost" data-testid="result-trend">{{ $t('matches_lost_short') }}</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'ResultTrendBox',
    props: {
      matches: {
        type: Array,
        default: () => {
          return []
        }
      },
      teamId: {
        type: Number,
        default: () => {
          return 0
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .team-form {
        display: flex;

        &-item {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            color: var(--color-on-primary);
            width: 24px;
            height: 24px;
            border-radius: 4px;
            margin: 0 2px;

            @media screen and (max-width: 320px) {
              width: 22px;
              height: 22px;
              margin: 1px 2px;
            }

            &-won {
                background: var(--color-positive);
            }
            &-draw {
                background-color: var(--color-grey-mid);
            }
            &-lost {
                background-color: var(--color-negative);
            }
        }
    }
</style>
